// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

/**
 * InputWord
 */
export const zInputWord = z.object({
    word: z.string(),
    syllables: z.array(z.string()),
    expected_stress_index: z.int()
});

/**
 * ProcessingError
 */
export const zProcessingError = z.enum([
    'INVALID_AUDIO',
    'SEGMENTATION_FAILED',
    'INVALID_BASE64'
]);

/**
 * ErrorResponse
 */
export const zErrorResponse = z.object({
    success: z.literal(false).default(false),
    error: zProcessingError,
    timestamp: z.int()
});

/**
 * ScoresRequest
 */
export const zScoresRequest = z.object({
    recording_b64: z.string(),
    word: zInputWord,
    username: z.string().optional().default('no-name'),
    audio_authorization: z.boolean().optional().default(false)
});

/**
 * SyllableSegmentData
 */
export const zSyllableSegmentData = z.object({
    index: z.int().gte(0),
    syllable: z.string(),
    start_s: z.number().gte(0),
    end_s: z.number().gte(0),
    duration_s: z.number().gte(0)
});

/**
 * SyllableSegmentationData
 */
export const zSyllableSegmentationData = z.object({
    method: z.enum(['mermelstein', 'equal_split_fallback']),
    segments: z.array(zSyllableSegmentData)
});

/**
 * ScoreData
 */
export const zScoreData = z.object({
    length: z.int(),
    highest: z.int(),
    syllable_segmentation: zSyllableSegmentationData
});

/**
 * SuccessResponse
 */
export const zSuccessResponse = z.object({
    success: z.literal(true).default(true),
    data: zScoreData,
    timestamp: z.int()
});

/**
 * ValidationError
 */
export const zValidationError = z.object({
    loc: z.array(z.union([z.string(), z.int()])),
    msg: z.string(),
    type: z.string(),
    input: z.unknown().optional(),
    ctx: z.record(z.string(), z.unknown()).optional()
});

/**
 * HTTPValidationError
 */
export const zHttpValidationError = z.object({
    detail: z.array(zValidationError).optional()
});

export const zGetProminentB64Body = zScoresRequest;

/**
 * Response Get Prominent B64
 *
 * Successful Response
 */
export const zGetProminentB64Response = z.union([
    zSuccessResponse,
    zErrorResponse
]);
